
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faq9tl_45Leq5X9SvDwfSEi15cvE13THhtzpIgrNvbhv2wcgMeta } from "/codebuild/output/src3935824937/src/src/pages/faq.vue?macro=true";
import { default as menuUqp_45WgP_45maa_Iz7IvIrz7P1EQMNRR8B_bi5OybZRANIMeta } from "/codebuild/output/src3935824937/src/src/pages/menu.vue?macro=true";
import { default as indexQdyNetaPDSrPBrtfLAm8fNWZ1LDzbdO55v8yrxVQbikMeta } from "/codebuild/output/src3935824937/src/src/pages/index.vue?macro=true";
import { default as contactuyOEuaMr34Vmuwso2Ob_45oPc14jnbiaTaXotLAuWLjssMeta } from "/codebuild/output/src3935824937/src/src/pages/contact.vue?macro=true";
import { default as tutorialx_xfC9_458kdeJvJOiOV1xUQc4tisl_454coFJiOlSRp3z4Meta } from "/codebuild/output/src3935824937/src/src/pages/tutorial.vue?macro=true";
import { default as agreement9wABk2SMjst0m6_sXlZWDODvAqRKFr1eTNl5qF6FbAoMeta } from "/codebuild/output/src3935824937/src/src/pages/agreement.vue?macro=true";
import { default as about_45passD71q_45nw5Hdi_jzpj33rULFh_APVqX70KKbi5C5PlhF8Meta } from "/codebuild/output/src3935824937/src/src/pages/about-pass.vue?macro=true";
import { default as indexvqwKwdpAJuXC5XKKGaQW_45PjMGLHM_45hpno0mgDvDf1CwMeta } from "/codebuild/output/src3935824937/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93XQhb6wFf8JSxRzpSkAIK0aGNrIFRc9LAI6cjVKzPj2cMeta } from "/codebuild/output/src3935824937/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancegvk7Y2Xrn4sgY3FpmdNluZ0wIXU85q2uz7vr4gvNtZcMeta } from "/codebuild/output/src3935824937/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_9361KckxkO904DY941p4_3dfZed5XGz6pMArenuAIWEDoMeta } from "/codebuild/output/src3935824937/src/src/pages/notice/[id].vue?macro=true";
import { default as indexYLImCnyYJpvbUH9CQpoJiDPyskjFVZQ3VHVxQ5BU3Z4Meta } from "/codebuild/output/src3935824937/src/src/pages/coupon/index.vue?macro=true";
import { default as indexbLFTVhbIm6JEHODE18mG0BFgFsrsO1YU4jSGytErWGYMeta } from "/codebuild/output/src3935824937/src/src/pages/mypage/index.vue?macro=true";
import { default as indexOsXy1JpqioOu__45gqAMJnOmuyP3nohsSHASm0cBvCECMMeta } from "/codebuild/output/src3935824937/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93ppdLd_pGE7AfDaZbW0ae5Kq9gsF2DD4VzybvVOlBbisMeta } from "/codebuild/output/src3935824937/src/src/pages/parking/[id].vue?macro=true";
import { default as indextfm_9Zi9KbMsU9RavmPVXE2AXfHtRsm6o8_VLoZ1IE0Meta } from "/codebuild/output/src3935824937/src/src/pages/history/index.vue?macro=true";
import { default as indexDTKdTSg3cbPPY_45rNQs1SE_45P7gMEkFOZXGidxVYJrmz4Meta } from "/codebuild/output/src3935824937/src/src/pages/monthly/index.vue?macro=true";
import { default as indexfqftUGNnPJPpZUK5jwhppQ_45OmQVMK_45oE_QnGW7oAwwwMeta } from "/codebuild/output/src3935824937/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexvsuPamnTynUFb8wGTMNU3jCxAhb_45pmsLmq2dtVqMxcYMeta } from "/codebuild/output/src3935824937/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviX6yyQiJCjIttFi5MKiqFSo5bWI_cT26o2x47LiIrfEQMeta } from "/codebuild/output/src3935824937/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editV_45wMsDLwOzKgHdXo68zxhPiOYH2PiXWxB1FXEpjfs_IMeta } from "/codebuild/output/src3935824937/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementrY0XcGduT3IddjkXHUNL5FkoEBGB07EXn_Zv80PUGUwMeta } from "/codebuild/output/src3935824937/src/src/pages/pass-agreement.vue?macro=true";
import { default as index2LDWgwvAEn5OY6ONNaXurSFT2rES__45_cniYPN9BHAjAMeta } from "/codebuild/output/src3935824937/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dE9QZN1Qi9MNA_451JpOhUO8JUkyde_45TKI3i8A_kYd68fgMeta } from "/codebuild/output/src3935824937/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirm_QEC_6OeW92ghjrvHtlmpq1ekrthbB1qygyt1bbucUEMeta } from "/codebuild/output/src3935824937/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as index3fp1IwQAWSMMRWhEZsFYnmFXm3xnSpUnUWaZYgW_450aYMeta } from "/codebuild/output/src3935824937/src/src/pages/card/create/index.vue?macro=true";
import { default as indexlUS6fRcz8RbHrBNct99TxV1d0pvvLhQFnZWUkwF03vsMeta } from "/codebuild/output/src3935824937/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirm294FV7i8lOM7BLwGpp1n9D8MCgzGPTbp9I_VTHIPBZ0Meta } from "/codebuild/output/src3935824937/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirm67N1bPp8jA8QDMW5RePfW1MSIPG55tj5HkmtmrA4aW8Meta } from "/codebuild/output/src3935824937/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeX_45Jozejjxwu2UfHlJ5NhicAQG4obkmU9e8fOuI6QBO0Meta } from "/codebuild/output/src3935824937/src/src/pages/membership/complete.vue?macro=true";
import { default as registerVkuPyHuU7t6p4n9eseI_45A80KnsBfYtbds3_45NZHKfBX8Meta } from "/codebuild/output/src3935824937/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93zZg3prCGImK4MoXEchzXGCUXbMKA4svNuOREAz4tZowMeta } from "/codebuild/output/src3935824937/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmgobqN11De9rbtxCOzLdzZCVT185VQFytB7_45xqfxRzZYMeta } from "/codebuild/output/src3935824937/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93Y5Y5IM0adigxz2E5xroIqGcxiMyCHYPHUvuVZLjGasEMeta } from "/codebuild/output/src3935824937/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexee5Bi6KzVlUNVIa6w4YxjbEC_rHsj86Hj_36e_45YZfRIMeta } from "/codebuild/output/src3935824937/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45coderhgfGOANF8PuUhbYGi_PCZGCEOd8JvvzFFU1t0f_L6YMeta } from "/codebuild/output/src3935824937/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45code2tpxNTdVX6NdSqJxiJ1nBkWEadXcKVeMipLO1GFBIrgMeta } from "/codebuild/output/src3935824937/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeDANwdDdKuhcfmQMTX6qo2XZUHVw9JvM1HgSSnNcK5I0Meta } from "/codebuild/output/src3935824937/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registern_45SMDyFLeGdffCtr2XAzi5WdR_45_ibBN0NiDoyXdZFPYMeta } from "/codebuild/output/src3935824937/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeidqqvnklTyUrvr9Vhe1RUXC3EnSY8VMk6b4PWLHvXFMMeta } from "/codebuild/output/src3935824937/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexMdD9O03LJbfrmplvOEh1wu6J_2G5BPB6lY2nTXrB0awMeta } from "/codebuild/output/src3935824937/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmvEfDRQ186mArRTI6m_45VCVtL5iKEkNh_vjx1I69nprlYMeta } from "/codebuild/output/src3935824937/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeY3VHK7QU7LCA7di125Dpp5oF08SyBm8xiNYa2EyhnREMeta } from "/codebuild/output/src3935824937/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexoo79Mh6t5k3HsU_VZmJ1W4ScTnASwF0asxweGu2vt_oMeta } from "/codebuild/output/src3935824937/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93cNwkrHGFYTXXz2j5VqsL39ewJPEWagY_45n39q1hQyQlQMeta } from "/codebuild/output/src3935824937/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete5eO1oCd7zbsWBd0uCxbj_4oq8DzNeIfF35Z8yuUgcmEMeta } from "/codebuild/output/src3935824937/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasjAcDtQWLefcRgj1Z_JmRqzuzGKBYmwbN6SNZTIEDDAwMeta } from "/codebuild/output/src3935824937/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleQY3HBKLAodfRKGM_z203I0rkZ6FHLhVzZfKh39QfuYsMeta } from "/codebuild/output/src3935824937/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailA_K2xfCqIOmudxf3pJYLLNZeMPI_dThJmFTqmPqrqREMeta } from "/codebuild/output/src3935824937/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmv5fs_JAeRP8SPkvfHWbT_45qcf3ihBfsu9U4PoTyRHivYMeta } from "/codebuild/output/src3935824937/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentHyvPOj2AVpzglIlXlA6vC8j47rqvhbCImz5MfZPlb_kMeta } from "/codebuild/output/src3935824937/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirm_L6Uy79WkF25XoMk99P_ylPGEB4sAZhbTqsJckJjJ6YMeta } from "/codebuild/output/src3935824937/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate223QfSWcoi5lvpi91jC31MdGUz5YruKirzhozKi4rP4Meta } from "/codebuild/output/src3935824937/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeg_45yAzNu26LG5z2xPOpArIelOHZ_ct3tlSyzr0F8IpBMMeta } from "/codebuild/output/src3935824937/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeZQqFhIm3aOcGr3HnAP8yEl8G331DGKNCWZdP0RfAovMMeta } from "/codebuild/output/src3935824937/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordeyaWCSRfMvjihtmlF9PsuOPsUCwLgHD9oEJTWDzG5AUMeta } from "/codebuild/output/src3935824937/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasiNsgg0ok9NGkGcuFwx29UZwq7mHcDWPB_j6vQt0Ue_0Meta } from "/codebuild/output/src3935824937/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerRL7xaETU9Gbjw7OFl8tNfmzIJMHBJ3v07hNjiUWNw3cMeta } from "/codebuild/output/src3935824937/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45code8Li2t9f0JxrYkA7Fe1Z5bZ47aqVW__Ui9phtO9uDIZ8Meta } from "/codebuild/output/src3935824937/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexUaTlYLssCm_453gEkEymrBjkkgrb9K07IgNBHACw_wj4UMeta } from "/codebuild/output/src3935824937/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as index7HnHix1PJeb6aU0Zs5KSTxBY49Cr9SICQJejw9ONUEgMeta } from "/codebuild/output/src3935824937/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index3dYOLcj0JUUwPZuBe1k2TvvhPrHskvhl8gMF6JNwDUkMeta } from "/codebuild/output/src3935824937/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexjc2fYRsmZUA8x93wSS9fCadCmytXN7rfFGSe3tDZjpYMeta } from "/codebuild/output/src3935824937/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateu74Lwb6GfnmrkY5EOR281zA59oLvVPOOXPzI5VhZRy4Meta } from "/codebuild/output/src3935824937/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completekB9NBLyNzK3n0wIeJOuCK6fHF1pBuF8BcnMvIPKerX4Meta } from "/codebuild/output/src3935824937/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirm5UxQhC9nVuSNXnJY8ds6yo7YKfg_3i0hetsZBnfFyzMMeta } from "/codebuild/output/src3935824937/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexbKukaDn86Yh_45a6I1uzIWJ_oLmVHjtgbhNaDd_45mDkWdQMeta } from "/codebuild/output/src3935824937/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeMEy2JMLFjDMT_14L7MvBJ9DxQAuG7RjZ02WDEdLhoOwMeta } from "/codebuild/output/src3935824937/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update7Chm4Xz9DVXxtVtYT6ww3Qhf5rxFUknSgr9ZVpcGiBcMeta } from "/codebuild/output/src3935824937/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexRXZ1UDq2qP3FqYOLq8umDpcYZgMlLclsttY_45QnWCedYMeta } from "/codebuild/output/src3935824937/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexFGujkpIQmrC_7sN8R_45_Rt7_aj2IN8n38nwV7nzawSfIMeta } from "/codebuild/output/src3935824937/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as complete5CDYuqa0h4gUbKZ1IW5bjPW3yTRwEiXV_MEL0fslMWsMeta } from "/codebuild/output/src3935824937/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexp2awcf_45yiLG9LyruDUVk9Xk5CbZZuVu40WCra26AggkMeta } from "/codebuild/output/src3935824937/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45code96mMFXVOJMYQ_jCqHgpou2DwIhNLKu7VoAf9Qipib0cMeta } from "/codebuild/output/src3935824937/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexUQ2SRQA1HRJc7e47BrFx2RHFwqm6xP2kqaTgW9oPgsYMeta } from "/codebuild/output/src3935824937/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexcZmYfsCnjmqKYQ4wl3tx1Ilz_B3nIJGo5nJUR_brCrQMeta } from "/codebuild/output/src3935824937/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexiC9JuNO69qo91jUxcz_455EV7JDvdFHUW_45KLnAc_45FhPX8Meta } from "/codebuild/output/src3935824937/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateIn_45p2Rb4wtJxjxuzfhnXMXzyAXvgm6_68wCCYXIrPM8Meta } from "/codebuild/output/src3935824937/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmGcxXhOPs330r4eb9T0pevvexxn41Ed4QhdvZv2s5U6sMeta } from "/codebuild/output/src3935824937/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuUqp_45WgP_45maa_Iz7IvIrz7P1EQMNRR8B_bi5OybZRANIMeta || {},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexQdyNetaPDSrPBrtfLAm8fNWZ1LDzbdO55v8yrxVQbikMeta || {},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexYLImCnyYJpvbUH9CQpoJiDPyskjFVZQ3VHVxQ5BU3Z4Meta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3935824937/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indextfm_9Zi9KbMsU9RavmPVXE2AXfHtRsm6o8_VLoZ1IE0Meta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3935824937/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexfqftUGNnPJPpZUK5jwhppQ_45OmQVMK_45oE_QnGW7oAwwwMeta || {},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexvsuPamnTynUFb8wGTMNU3jCxAhb_45pmsLmq2dtVqMxcYMeta || {},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: index3fp1IwQAWSMMRWhEZsFYnmFXm3xnSpUnUWaZYgW_450aYMeta || {},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirm294FV7i8lOM7BLwGpp1n9D8MCgzGPTbp9I_VTHIPBZ0Meta || {},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirm67N1bPp8jA8QDMW5RePfW1MSIPG55tj5HkmtmrA4aW8Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3935824937/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeX_45Jozejjxwu2UfHlJ5NhicAQG4obkmU9e8fOuI6QBO0Meta || {},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerVkuPyHuU7t6p4n9eseI_45A80KnsBfYtbds3_45NZHKfBX8Meta || {},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmgobqN11De9rbtxCOzLdzZCVT185VQFytB7_45xqfxRzZYMeta || {},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45coderhgfGOANF8PuUhbYGi_PCZGCEOd8JvvzFFU1t0f_L6YMeta || {},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45code2tpxNTdVX6NdSqJxiJ1nBkWEadXcKVeMipLO1GFBIrgMeta || {},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeDANwdDdKuhcfmQMTX6qo2XZUHVw9JvM1HgSSnNcK5I0Meta || {},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registern_45SMDyFLeGdffCtr2XAzi5WdR_45_ibBN0NiDoyXdZFPYMeta || {},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmvEfDRQ186mArRTI6m_45VCVtL5iKEkNh_vjx1I69nprlYMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3935824937/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeY3VHK7QU7LCA7di125Dpp5oF08SyBm8xiNYa2EyhnREMeta || {},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexoo79Mh6t5k3HsU_VZmJ1W4ScTnASwF0asxweGu2vt_oMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3935824937/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete5eO1oCd7zbsWBd0uCxbj_4oq8DzNeIfF35Z8yuUgcmEMeta || {},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleQY3HBKLAodfRKGM_z203I0rkZ6FHLhVzZfKh39QfuYsMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3935824937/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailA_K2xfCqIOmudxf3pJYLLNZeMPI_dThJmFTqmPqrqREMeta || {},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmv5fs_JAeRP8SPkvfHWbT_45qcf3ihBfsu9U4PoTyRHivYMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3935824937/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentHyvPOj2AVpzglIlXlA6vC8j47rqvhbCImz5MfZPlb_kMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3935824937/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirm_L6Uy79WkF25XoMk99P_ylPGEB4sAZhbTqsJckJjJ6YMeta || {},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeg_45yAzNu26LG5z2xPOpArIelOHZ_ct3tlSyzr0F8IpBMMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3935824937/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeZQqFhIm3aOcGr3HnAP8yEl8G331DGKNCWZdP0RfAovMMeta || {},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordeyaWCSRfMvjihtmlF9PsuOPsUCwLgHD9oEJTWDzG5AUMeta || {},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerRL7xaETU9Gbjw7OFl8tNfmzIJMHBJ3v07hNjiUWNw3cMeta || {},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45code8Li2t9f0JxrYkA7Fe1Z5bZ47aqVW__Ui9phtO9uDIZ8Meta || {},
    component: () => import("/codebuild/output/src3935824937/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3935824937/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]